import { checkBitrixResponse } from 'tools';

export default class B2bMessagePopup {
    constructor() {
        this.$popup = $('.b2b-unseen-message-popup');
        this.$popup.modal('show');
        this.bind();
    }

    static init() {
        if ($('.b2b-unseen-message-popup').length) {
            new B2bMessagePopup();
        }
    }

    bind() {
        $('.b2b-unseen-message-popup__mark-seen').on('click', this.markAsSeen.bind(this));
    }

    markAsSeen() {
        $.ajax({
            url: `/bitrix/services/main/ajax.php?c=${encodeURIComponent('nav:b2b.message.unseen_popup')}&mode=class&action=markAsSeen`,
            data: {
                id: this.$popup.attr('data-id'),
                sessid: app.sessid,
            },
            type: 'get',
        }).done((response) => {
            if (!checkBitrixResponse(response)) {
                return;
            }

            this.$popup.modal('hide');
        });
    }
}